function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, useMemo } from 'react';
export var useErrorBoundary = WrappedComponent => useMemo(() => class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderError: null
    };
  }
  static getDerivedStateFromError(renderError) {
    return {
      renderError
    };
  }
  render() {
    var {
      props,
      state
    } = this;
    var {
      renderError
    } = state;
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      renderError: renderError
    }));
  }
}, []);